var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-grid',{attrs:{"column-num":3,"icon-size":"40","border":false}},_vm._l((_vm.navs),function(item,index){return _c('van-grid-item',{key:index,attrs:{"icon":item.picUrl,"text":item.text,"url":item.linkUrl}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }